module.exports = __webpack_public_path__ + "media/alert.0a2c73b5.mp3";